import { useAuth } from '@context/auth/base';
import { gql, SortOrder, useInfiniteQuery, UserReleaseTokensDocument } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query userReleaseTokens(
    $id: UUID!
    $filter: UserNftsConnectionFilters
    $pagination: NftCursorConnectionArgs!
  ) {
    user(id: $id) {
      id
      nftsPaginated(filter: $filter, pagination: $pagination) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            tokenId
            songSlot
            isGoldenEgg
            tierNumber
            comment {
              id
              message
            }
            owner {
              id
              publicAddress
            }
            serialNumber
          }
          cursor
        }
      }
    }
  }
`);

export const useReleaseTokens = ({ releaseId }: { releaseId: string }) => {
  const { authUser } = useAuth();
  const userId = authUser?.id ?? '';

  const {
    orderedList: nftsOwnedByUser,
    loadMoreNextPage: loadMore,
    isLoading: loading,
  } = useInfiniteQuery(UserReleaseTokensDocument, {
    enabled: !!userId,
    filterQueryKey: {
      userId,
      releaseId,
    },
    getNextPageParam({ data }) {
      return (
        data.user?.nftsPaginated.pageInfo.hasNextPage && {
          after: data.user.nftsPaginated.pageInfo.endCursor,
        }
      );
    },
    variables({ pageParam }) {
      return {
        filter: { releases: [releaseId] },
        id: userId,
        pagination: {
          after: pageParam?.after || null,
          first: 50,
          sort: {
            serialNumber: SortOrder.Asc,
          },
        },
      };
    },
    list({ user }) {
      return user?.nftsPaginated.edges.map(edge => edge.node);
    },
    uniq({ id }) {
      return id;
    },
    staleTime: 0,
  });

  return {
    nftsOwnedByUser,
    loadMore,
    loading,
  };
};
